import PastAppointmentsContainer from './PastAppointmentsContainer';

export default PastAppointmentsContainer;



// WEBPACK FOOTER //
// ./src/components/Pages/Appointments/PastAppointments/index.js